export enum ImporterID {
  Spotify = 'spotify',
  Youtube = 'youtube',
  AppleMusic = 'apple-music',
  AmazonMusic = 'amazon-music',
  Tidal = 'tidal',
  Pandora = 'pandora',
  Deezer = 'deezer',
  SoundCloud = 'sound-cloud',
  Qobuz = 'qobuz',
  QQMusic = 'qq-music',
  Yandex = 'yandex',
  YouTubeMusic = 'youtube-music',
  Napster = 'napster',
  VK = 'vk',
  Zvuk = 'zvuk',
  Gaana = 'gaana',
  JioSaavn = 'jiosaavn',
  Resso = 'resso',
  Boomplay = 'boomplay',
  Audiomack = 'audiomack',
  File = 'file-backup',
  Audius = 'audius',
  /**
   * The demo destination. Not a music service: it accepts a transfer, matches
   * against nothing, and stores what it was given so Demoify can show it.
   */
  Demo = 'demoify',
  /** The demo source: a library we ship, so the demo needs no account. */
  Sample = 'sample-library',
  /**
   * The QA test services of the FYM apps: fake music services that need no
   * login. "Test Spotify" can do everything; "Test Apple Music" has Apple
   * Music's limits. musicapi offers them only when `FYM_TEST_SERVICES_ENABLED`
   * is on and the app sends `x-fym-test-services: 1`. They have no
   * `MusicAPIIntegrationID` and are in no picker of any app or website.
   */
  FymTestSpotify = 'fym-test-spotify',
  FymTestAppleMusic = 'fym-test-apple-music',
}

export enum MusicAPIIntegrationID {
  Spotify = 'spotify',
  Youtube = 'youtube',
  AppleMusic = 'appleMusic',
  AmazonMusic = 'amazonMusic',
  Tidal = 'tidal',
  Resso = 'resso',
  Boomplay = 'boomplay',
  Deezer = 'deezer',
  Pandora = 'pandora',
  SoundCloud = 'soundCloud',
  YoutubeMusic = 'youtubeMusic',
  Napster = 'napster',
  Qobuz = 'qobuz',
  QQMusic = 'qqMusic',
  YandexMusic = 'yandexMusic',
  VKMusic = 'vkMusic',
  Zvuk = 'zvuk',
  Gaana = 'gaana',
  JioSaavn = 'jiosaavn',
  Audiomack = 'audiomack',
  Audius = 'audius',
  Demo = 'demo',
  Sample = 'sample',
}

/**
 * The importers behind the public demo, which are not music services.
 *
 * Both exist so the transfer engine can address them; neither has a public
 * API, a catalogue or anything to search. Anything enumerating services for
 * the outside world has to leave them out — the search sources are the case
 * that found this.
 */
export const demoOnlyImporterIds: ImporterID[] = [ImporterID.Demo, ImporterID.Sample];

export const isDemoOnlyImporterId = (importerId: ImporterID): boolean => demoOnlyImporterIds.includes(importerId);

/** The two QA test services (`fym-test-*`). See `services/FymTestServices.ts`. */
export const fymTestImporterIds: ImporterID[] = [ImporterID.FymTestSpotify, ImporterID.FymTestAppleMusic];

export const isFymTestImporterId = (importerId: string): boolean =>
  (fymTestImporterIds as string[]).includes(importerId);
